/** 复制修改自 landingpage/sasdkinit.js */

import sdks, { EVENTS } from '@/utils/_sasdk'
import cookie from 'js-cookie'

// 注册公共属性
sdks.registerPage({
  object_version: 'v1.0.0',
  business: 'VIPKIDmath',
  object: 'Math_Briefing',
  app_id: '703dc5d1afbb9d76',
  student_id: cookie.get('mbstudentid') || '',
  parent_id: cookie.get('mbparentid') || ''
})

const sasdk = Object.assign(
  {
    watchVideo () {
      console.log('Math_Briefing_VideoPlay_click')
      this.track(EVENTS.click, {
        event_id: 'Math_Briefing_VideoPlay_click',
        str1: '观看视频'
      })
    },
    receiveFreeCourse () {
      console.log('Math_Briefing_FreeCourse_click')
      this.track(EVENTS.click, {
        event_id: 'Math_Briefing_FreeCourse_click',
        str1: '验证码输入后点击“免费领取数学思维课”'
      })
    },
    joinRightNow () {
      console.log('Math_Briefing_JoinRightNow_click')
      this.track(EVENTS.click, {
        event_id: 'Math_Briefing_JoinRightNow_click',
        str1: '点击立即参加发布会'
      })
    }
  },
  sdks
)

export default sasdk
